import { z } from "zod";
import { RichTextBladeSchema } from "../../../schemas/blades/RichText";
import { ArticleRichTextBlade } from "../../ArticleRichText";
export const LandingRichTextBladeContractSchema = RichTextBladeSchema.extend({
    type: z.literal("landingRichText"),
});
export const LandingRichTextBlade = ArticleRichTextBlade;
//# sourceMappingURL=LandingTextBlade.js.map